<template>
  <div id="authorization">
    <div class="header">
      <img src="@/assets/zamonuz.png" alt="" />
    </div>
    <div class="main">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  setup() {},
};
</script>

<style lang="scss" scoped>
#authorization {
  // background
  --form-bg: #ffffff;
  --input-bg: rgba(243, 243, 243,1);
  --input-focus-bg: rgba(254, 254, 254, 1);

  // color
  --light: rgba(255, 255, 255, 1);
  --warning-danger: rgba(211, 77, 77, 1);
  --explanation-color: rgba(108, 143, 186, 1);
  --back-btn: rgba(128, 128, 128, 1);
  --content-opacity: rgba(128, 128, 128, 0.8);
  --title-color: rgba(93, 93, 93, 1);
  --title-opacity-color: rgba(93, 93, 93, 0.7);
  --title-light: rgba(128,128,128, 0.3);
  --light-primary: rgba(166, 181, 199, 1);
  --final-btn: rgba(29, 82, 149, 1);

  --input-border: 1px solid #cccccc;

  background: url('~@/assets/authorization.png') no-repeat center center/cover;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   justify-content: center;
  .header {
    height: 10.052vw;
    margin-top: 3.125rem;
    img {
      height: 10.052vw;
    }
  }
  .main {
    background: #ffff;
    display: flex;
    justify-content: center;
    margin-top: 3.438rem;
  }
}

@media screen and (max-width: 1366px) {
  #authorization {
    height: 100vh;
    .header {
      height: 9.438rem;
      img {
        height: 9.438rem;
      }
      .main {
        margin-top: 5.063rem;
      }
    }
  }
}
@media screen and (max-width: 540px) {
  #authorization {
    height: 100vh;
    .header {
      height: 5.188rem;
      img {
        height: 5.188rem;
      }
    }
    .main {
      margin-top: 3.125rem;
    }
  }
}
</style>
